import React from 'react';
import SectionWrapper from 'Components/SectionWrapper/SectionWrapper.js';
import './Krankheitsbilder.css';

const Krankheitsbilder = () =>
      <div>
        <SectionWrapper title="Krankheitsbilder">
        <div className="krankheitsbilder-content">
            <ul className="list">
                <li>Durchblutungsstörungen der hirnversorgenden Gefäße</li>
                <li>Durchblutungsstörungen der Arm- und Beinschlagadern</li>
                <li>Periphere arterielle Verschlußkrankheit - akuter Arterienverschluß</li>
                <li>Vaskulitiden - vasospastische Erkrankungen - arterielle Kompressionssyndrome</li>
                <li>Durchblutungsstörungen der Bauchorgane, insbesondere der Nieren</li>
                <li>Schlagaderaussackungen (Aneurysmen)</li>
                <li>Angiodysplasie - Arteriovenöse Fistel - Aneurysma spurium</li>
                <li>Venenerkrankungen: Varikose, chronisch venöse Insuffizienz, Thrombophlebitis, tiefe Venenthrombose</li>
                <li>Lymphödem</li>
                <li>Chronische Wunden - Diabetischer Fuß - Ulcus cruris</li>
            </ul>
            <h2 className="krankheitsbilder-subtitle">Anleitung zum Gehtraining</h2>
            <a
              className="pdf-card"
              href="/Gehen-gegen-die-Schaufensterkrankheit.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="pdf-card-icon">PDF</span>
              <span className="pdf-card-text">
                <strong>Gehen gegen die Schaufensterkrankheit</strong>
                <span>Anleitung als PDF öffnen</span>
              </span>
            </a>
        </div>
        </SectionWrapper>
    </div>
export default Krankheitsbilder;
